module.exports = __webpack_public_path__ + "img/designer-avatar.85c96071.png";